import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';

export function OpeningsPopover() {
  const [open, setOpen] = useState(false);
  const { selectedOpeningIds, hookForm } = useJobPostingContext();
  const { getValues } = hookForm;

  if (selectedOpeningIds.length === 1) {
    return (
      <Typography variant="subtitle1" className="max-w-[240px] truncate">
        {getValues(`jobDetails.${selectedOpeningIds[0]}.title`)}
      </Typography>
    );
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="link" className="h-fit hover:no-underline">
          <FormattedMessage
            defaultMessage="{count} Openings"
            values={{ count: selectedOpeningIds.length }}
          />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="flex w-auto min-w-[240px] max-w-[320px] flex-col items-start justify-center"
      >
        {selectedOpeningIds.map(openingId => (
          <div
            key={openingId}
            className="flex w-full items-center justify-between py-2"
          >
            <Typography variant="subtitle1">
              {getValues(`jobDetails.${openingId}.title`)}
            </Typography>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
